module.exports = __webpack_public_path__ + "img/map-g.3da9e994.png";